"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zeroZone = _interopRequireDefault(require("./components/zeroZone"));
var _beijingZone = _interopRequireDefault(require("./components/beijingZone"));
var _default = exports.default = {
  components: {
    ZeroZone: _zeroZone.default,
    BeijingZone: _beijingZone.default
  },
  data: function data() {
    return {
      activeName: 'zeroZone'
    };
  }
};